import { ref } from 'vue'
import { BASE_URL } from "@/composables/url_config"
import { log } from "@/composables/useLog"
import axios from "axios"

const error = ref(null)

const getHeaders = (token) => ({
  "Authorization": `Bearer ${token}`,
  "Content-Type": "application/json",
  "Accept": "application/json"
})

// Good Categories API
export const getGoodCategories = async (token) => {
  log("welcome in getGoodCategories")

  if (!token || token === "") {
    return { error: true, message: "No token provided", good_categories: [] }
  }

  try {
    const url = BASE_URL + '/home/getGoodCategoriesApi'
    const result = await axios.get(url, { headers: getHeaders(token) })
    log("result.data from getGoodCategories")
    log(result.data)
    return result.data
  } catch (err) {
    log("Error in getGoodCategories")
    log(err)
    error.value = err.message
    return { error: true, message: "Error fetching good categories", good_categories: [] }
  }
}

export const saveGoodCategory = async (token, categoryData) => {
  log("welcome in saveGoodCategory")
  log(categoryData)

  if (!token || token === "") {
    return { error: true, message: "No token provided" }
  }

  try {
    const url = BASE_URL + '/home/saveGoodCategoryApi'
    const result = await axios.post(url, categoryData, { headers: getHeaders(token) })
    log("result.data from saveGoodCategory")
    log(result.data)
    return result.data
  } catch (err) {
    log("Error in saveGoodCategory")
    log(err)
    error.value = err.message
    return { error: true, message: "Error saving good category" }
  }
}

export const deleteGoodCategory = async (token, categoryId) => {
  log("welcome in deleteGoodCategory for id=" + categoryId)

  if (!token || token === "") {
    return { error: true, message: "No token provided" }
  }

  try {
    const url = BASE_URL + '/home/deleteGoodCategoryApi'
    const result = await axios.delete(url, { headers: getHeaders(token), params: { id: categoryId } })
    log("result.data from deleteGoodCategory")
    log(result.data)
    return result.data
  } catch (err) {
    log("Error in deleteGoodCategory")
    log(err)
    error.value = err.message
    return { error: true, message: "Error deleting good category" }
  }
}

// Inventory Statuses API
export const getInventoryStatuses = async (token) => {
  log("welcome in getInventoryStatuses")

  if (!token || token === "") {
    return { error: true, message: "No token provided", inventory_statuses: [] }
  }

  try {
    const url = BASE_URL + '/home/getInventoryStatusesApi'
    const result = await axios.get(url, { headers: getHeaders(token) })
    log("result.data from getInventoryStatuses")
    log(result.data)
    return result.data
  } catch (err) {
    log("Error in getInventoryStatuses")
    log(err)
    error.value = err.message
    return { error: true, message: "Error fetching inventory statuses", inventory_statuses: [] }
  }
}

export const saveInventoryStatus = async (token, statusData) => {
  log("welcome in saveInventoryStatus")
  log(statusData)

  if (!token || token === "") {
    return { error: true, message: "No token provided" }
  }

  try {
    const url = BASE_URL + '/home/saveInventoryStatusApi'
    const result = await axios.post(url, statusData, { headers: getHeaders(token) })
    log("result.data from saveInventoryStatus")
    log(result.data)
    return result.data
  } catch (err) {
    log("Error in saveInventoryStatus")
    log(err)
    error.value = err.message
    return { error: true, message: "Error saving inventory status" }
  }
}

export const deleteInventoryStatus = async (token, statusId) => {
  log("welcome in deleteInventoryStatus for id=" + statusId)

  if (!token || token === "") {
    return { error: true, message: "No token provided" }
  }

  try {
    const url = BASE_URL + '/home/deleteInventoryStatusApi'
    const result = await axios.delete(url, { headers: getHeaders(token), params: { id: statusId } })
    log("result.data from deleteInventoryStatus")
    log(result.data)
    return result.data
  } catch (err) {
    log("Error in deleteInventoryStatus")
    log(err)
    error.value = err.message
    return { error: true, message: "Error deleting inventory status" }
  }
}

// Goods Inventories API
export const getGoodsInventories = async (token, params = {}) => {
  log("welcome in getGoodsInventories")
  log(params)

  if (!token || token === "") {
    return { error: true, message: "No token provided", goods_inventories: [], pagination: {} }
  }

  try {
    const url = BASE_URL + '/home/getGoodsInventoriesApi'
    const result = await axios.get(url, { headers: getHeaders(token), params })
    log("result.data from getGoodsInventories")
    log(result.data)
    return result.data
  } catch (err) {
    log("Error in getGoodsInventories")
    log(err)
    error.value = err.message
    return { error: true, message: "Error fetching goods inventories", goods_inventories: [], pagination: {} }
  }
}

export const saveGoodsInventory = async (token, inventoryData) => {
  log("welcome in saveGoodsInventory")
  log(inventoryData)

  if (!token || token === "") {
    return { error: true, message: "No token provided" }
  }

  try {
    const url = BASE_URL + '/home/saveGoodsInventoryApi'
    const result = await axios.post(url, inventoryData, { headers: getHeaders(token) })
    log("result.data from saveGoodsInventory")
    log(result.data)
    return result.data
  } catch (err) {
    log("Error in saveGoodsInventory")
    log(err)
    error.value = err.message
    return { error: true, message: "Error saving goods inventory" }
  }
}

export const deleteGoodsInventory = async (token, inventoryId) => {
  log("welcome in deleteGoodsInventory for id=" + inventoryId)

  if (!token || token === "") {
    return { error: true, message: "No token provided" }
  }

  try {
    const url = BASE_URL + '/home/deleteGoodsInventoryApi'
    const result = await axios.delete(url, { headers: getHeaders(token), params: { id: inventoryId } })
    log("result.data from deleteGoodsInventory")
    log(result.data)
    return result.data
  } catch (err) {
    log("Error in deleteGoodsInventory")
    log(err)
    error.value = err.message
    return { error: true, message: "Error deleting goods inventory" }
  }
}

export const updateGoodsInventoryStatus = async (token, updateData) => {
  log("welcome in updateGoodsInventoryStatus")
  log(updateData)

  if (!token || token === "") {
    return { error: true, message: "No token provided" }
  }

  try {
    const url = BASE_URL + '/home/updateGoodsInventoryStatusApi'
    const result = await axios.post(url, updateData, { headers: getHeaders(token) })
    log("result.data from updateGoodsInventoryStatus")
    log(result.data)
    return result.data
  } catch (err) {
    log("Error in updateGoodsInventoryStatus")
    log(err)
    error.value = err.message
    return { error: true, message: "Error updating goods inventory status" }
  }
}

// Goods Inventory Logs API
export const getGoodsInventoryLogs = async (token, params = {}) => {
  log("welcome in getGoodsInventoryLogs")
  log(params)

  if (!token || token === "") {
    return { error: true, message: "No token provided", goods_inventory_logs: [], pagination: {} }
  }

  try {
    const url = BASE_URL + '/home/getGoodsInventoryLogsApi'
    const result = await axios.get(url, { headers: getHeaders(token), params })
    log("result.data from getGoodsInventoryLogs")
    log(result.data)
    return result.data
  } catch (err) {
    log("Error in getGoodsInventoryLogs")
    log(err)
    error.value = err.message
    return { error: true, message: "Error fetching goods inventory logs", goods_inventory_logs: [], pagination: {} }
  }
}

// SIM Inventory API
export const addSimsToInventory = async (token, simIds, inventoryStatusId, clientId = null, location = null, notes = null) => {
  log("welcome in addSimsToInventory")
  log({ simIds, inventoryStatusId, clientId, location, notes })

  if (!token || token === "") {
    return { error: true, message: "No token provided" }
  }

  try {
    const url = BASE_URL + '/home/addSimsToInventoryApi'
    const result = await axios.post(url, {
      sim_ids: simIds,
      inventory_status_id: inventoryStatusId,
      client_id: clientId,
      location: location,
      notes: notes
    }, { headers: getHeaders(token) })
    log("result.data from addSimsToInventory")
    log(result.data)
    return result.data
  } catch (err) {
    log("Error in addSimsToInventory")
    log(err)
    error.value = err.message
    return { error: true, message: "Error adding SIMs to inventory" }
  }
}

export const getSimCategory = async (token) => {
  log("welcome in getSimCategory")

  if (!token || token === "") {
    return { error: true, message: "No token provided", category: null }
  }

  try {
    const url = BASE_URL + '/home/getSimCategoryApi'
    const result = await axios.get(url, { headers: getHeaders(token) })
    log("result.data from getSimCategory")
    log(result.data)
    return result.data
  } catch (err) {
    log("Error in getSimCategory")
    log(err)
    error.value = err.message
    return { error: true, message: "Error fetching SIM category", category: null }
  }
}

const useGoodsInventoryAPI = () => {
  return {
    error,
    getGoodCategories,
    saveGoodCategory,
    deleteGoodCategory,
    getInventoryStatuses,
    saveInventoryStatus,
    deleteInventoryStatus,
    getGoodsInventories,
    saveGoodsInventory,
    deleteGoodsInventory,
    updateGoodsInventoryStatus,
    getGoodsInventoryLogs,
    addSimsToInventory,
    getSimCategory
  }
}

export default useGoodsInventoryAPI
